"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var defaultDateFormat = 'MM/DD/YYYY';

function formatDate(date, format) {
  if (format === void 0) {
    format = defaultDateFormat;
  }

  return moment_1.default(date).format(format);
}

exports.formatDate = formatDate;

function parseDateFormat(date, format) {
  return moment_1.default(date, format);
}

exports.parseDateFormat = parseDateFormat;